/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  BannerListResponse,
  BannerRequest,
  BannerResponse,
  Error,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Banners<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags Banner
   * @name GetBanners
   * @request GET:/banners
   * @secure
   */
  getBanners = (
    query?: {
      /** Sort by attributes ascending (asc) or descending (desc) */
      sort?: string;
      /** Return page/pageSize (default: true) */
      "pagination[withCount]"?: boolean;
      /** Page number (default: 0) */
      "pagination[page]"?: number;
      /** Page size (default: 25) */
      "pagination[pageSize]"?: number;
      /** Offset value (default: 0) */
      "pagination[start]"?: number;
      /** Number of entities to return (default: 25) */
      "pagination[limit]"?: number;
      /** Fields to return (ex: title,author) */
      fields?: string;
      /** Relations to return */
      populate?: string;
      /** Filters to apply */
      filters?: Record<string, any>;
      /** Locale to apply */
      locale?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<BannerListResponse, Error>({
      path: `/banners`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Banner
   * @name PostBanners
   * @request POST:/banners
   * @secure
   */
  postBanners = (data: BannerRequest, params: RequestParams = {}) =>
    this.request<BannerResponse, Error>({
      path: `/banners`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Banner
   * @name GetBannersId
   * @request GET:/banners/{id}
   * @secure
   */
  getBannersId = (id: number, params: RequestParams = {}) =>
    this.request<BannerResponse, Error>({
      path: `/banners/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Banner
   * @name PutBannersId
   * @request PUT:/banners/{id}
   * @secure
   */
  putBannersId = (
    id: number,
    data: BannerRequest,
    params: RequestParams = {},
  ) =>
    this.request<BannerResponse, Error>({
      path: `/banners/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Banner
   * @name DeleteBannersId
   * @request DELETE:/banners/{id}
   * @secure
   */
  deleteBannersId = (id: number, params: RequestParams = {}) =>
    this.request<number, Error>({
      path: `/banners/${id}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });
}
